
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#8dc540","xmlns":"http://www.w3.org/2000/svg","width":"800","height":"800","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50 16v-6h4a2 2 0 002-2V2a2 2 0 00-2-2H10a2 2 0 00-2 2v6a2 2 0 002 2h4v6c0 6.967 3.986 13.01 9.792 16C17.986 34.99 14 41.033 14 48v6h-4a2 2 0 00-2 2v6a2 2 0 002 2h44a2 2 0 002-2v-6a2 2 0 00-2-2h-4v-6c0-6.967-3.986-13.01-9.792-16C46.014 29.01 50 22.967 50 16zM12 4h40v2H12V4zm40 56H12v-2h40v2zm-6-12v6H18v-6c0-7.72 6.28-14 14-14s14 6.28 14 14zM32 30c-7.72 0-14-6.28-14-14v-6h28v6c0 7.72-6.28 14-14 14z"}})])
          )
        }
      }
    